import { adminHttpClient } from "../../../../commons/adminHttpClinet";
import { MarketplacePurchaseStatisticsModel } from "../../../../models/dashboard/marketplace/affiliateStatisticsModel";


const getMarketplaceStatistics = (marketplaceId: string):Promise<MarketplacePurchaseStatisticsModel> => {

    return adminHttpClient.get(`/api/Admin/AdminMarketplace/get-marketplace-statistics?marketplaceId=${marketplaceId}`)

}
export default getMarketplaceStatistics;